<script>
  /**
   * オブジェクト配列データを GroupBy して ul/li 表示する
   *  ネストできるように slot で id, filtered を子コンポーネントに渡している
   */
  export let key
  export let rows

  // ユニークキーを抽出
  $: ids = Array.from(new Set(rows.map((row) => row[key])))
</script>

{#each ids as id, index}
  <slot {id} {index} filtered={rows.filter((row) => row[key] === id)} />
{/each}
